// extracted by mini-css-extract-plugin
export default {"modal":"DWAw8","modal-background":"WRt7R","top-container":"uS5Fa","title":"cNXhN","close":"BBjeI","description":"ShVoD","avatar":"v0AHK","button-container":"gwfHw"};